import { render, staticRenderFns } from "./assignmentsCount.vue?vue&type=template&id=ccae2770&"
import script from "./assignmentsCount.vue?vue&type=script&lang=js&"
export * from "./assignmentsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports